import { StyledSlider } from '@/pages/AdvancedEditor/components/panels/common/StyledSlider';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';
import { ControlNumberInput } from '../../common/ControlNumberInput';

const Container = styled.div`
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    width: 220px;
`;

export const OpacityControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const elements = store.selectedShapes;
    const element = elements[0] as ElementType & { opacity: number };

    if (!element) return null;

    const handleChange = (value: number) => {
        const opacity = parseFloat((value / 100).toFixed(2));

        elements.forEach(element => element.set({ opacity }));
    };

    const opacity = Math.round(element.opacity * 100);

    return (
        <Container>
            <StyledSlider value={opacity} onChange={(_e, value) => handleChange(value as number)} step={1} min={0} max={100} />

            <ControlNumberInput value={opacity} onChange={handleChange} min={0} max={100} suffix="%" />
        </Container>
    );
});
